import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card } from "semantic-ui-react";
import { DocumentTitle } from "../../app/components/document_title";
import { useAuth } from "../../app/context/auth_provider";
import { AccountListView } from "../../models/account/account";
import { Result } from "../../models/common/paged_result";
import { UserRole } from "../../models/user/user";
import { api } from "../../shared/axios_wrapper";

function AccountListPage() {
    const navigate = useNavigate();
    const {user} = useAuth();
    //const showFullSize = useMediaQuery({ query: `(${getFullSizeWidth()})` })
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<AccountListView[]>([] as AccountListView[]);

    useEffect(() => {
        if (user){
          setLoading(true);
            const url = `account/list`;
            api.get<Result<AccountListView[]>>(url)
            .then((r) => {
                if (r.data?.result)
                  setData(r.data.result);
            })
            .catch((e) => { toast.error("Error", { theme: "colored" }) })
            .finally(() => setLoading(false));
        }
    }, [user]);

    return(<>
        <DocumentTitle title="Accounts" />
        <h2>Accounts {data?.length > 0 ? `(${data?.length})` : ''}
        {user?.role === UserRole.SuperAdmin &&
       <Button floated='right' icon="add" content="Add Account" onClick={() => navigate("/admin/accounts/edit/0")}/>}
        </h2>
        <br/>
        {!loading && <Card.Group size="large" stackable centered>
          {data?.map((a, index) => (
           <Card key={"ac_" + a.id}>
           <Card.Content>
             <Card.Header><a href={"/accounts/" + a.id}>{a.name}</a></Card.Header>
             <Card.Meta>
                Active: {(a.active === true) ? "YES" : "NO"} &nbsp; | &nbsp;
                Active Locations: {a.activeLocationCount} &nbsp; | &nbsp;
                Active Users: {a.activeUserCount}
             </Card.Meta>
             <Card.Description>
               {a.description}
             </Card.Description>
           </Card.Content>
           <Card.Content extra textAlign="center">
              <Button basic primary icon='at' content='View' onClick={(e,data) => navigate('/accounts/' + a.id)}/>
              <Button basic icon='edit' content='Edit' onClick={(e,data) => navigate('/admin/accounts/edit/' + a.id)}/>
           </Card.Content>
         </Card>
          ))}
        </Card.Group>}
    </>);

}
export default AccountListPage;